function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getClaimGroupsService from '@rd-web-markets/shared/dist/services/claim_groups/getClaimGroups.service';
import ClaimGroupSelector from '@rd-web-markets/shared/dist/claim_group/ClaimGroupSelector';
import { getDashboardLink } from '../../util/getDashboardLink';
const SIDEBAR_WIDTH_EXPANDED = 240;
const SIDEBAR_WIDTH_COLLAPSED = 56;
const FLYOUT_WIDTH = 220;
const buildSections = (t, accountType) => [...(accountType !== 'customer' ? [[{
  key: 'claim_overview',
  icon: 'summarize',
  label: t('claim_overview') || 'Claim overview',
  link: 'master',
  flyout: null
}]] : []), [accountType === 'customer' ? {
  key: 'engagement_team',
  icon: 'settings',
  label: t('engagement_team') || 'Contacts',
  link: 'engagement_team',
  flyout: null
} : {
  key: 'settings',
  icon: 'settings',
  label: t('settings') || 'Settings',
  link: null,
  flyout: [{
    text: t('claim_info') || 'Claim settings',
    link: 'edit/general'
  }, {
    text: t('company_info') || 'Company info',
    link: 'edit_company_info'
  }, {
    text: t('engagement_team') || 'Contacts',
    link: 'engagement_team'
  }]
}, {
  key: 'files',
  icon: 'description',
  label: t('files') || 'Files',
  link: null,
  flyout: [...(accountType !== 'customer' ? [{
    text: t('import_data') || 'Import data',
    link: 'import_data'
  }] : []), {
    text: t('export_data') || 'Export data',
    link: 'export_data'
  }, {
    text: t('documents') || 'Documents',
    link: 'technical_uploads'
  }]
}, {
  key: 'dashboard',
  icon: 'dashboard',
  label: t('dashboard') || 'Dashboard',
  link: 'dashboard',
  flyout: null
}], [{
  key: 'projects',
  icon: 'assignment',
  label: t('projects') || 'Projects',
  link: 'project_overview',
  flyout: null
}, {
  key: 'costs',
  icon: 'currency_pound',
  label: t('costs') || 'Costs',
  link: null,
  flyout: [{
    text: t('qualifying_expenditure') || 'Qualifying expenditure',
    link: 'qualifying_expenditure'
  }, {
    text: t('cost_categories') || 'Cost categories',
    link: 'claim_costs'
  }, ...(accountType !== 'customer' ? [{
    text: t('cost_settings') || 'Cost settings',
    link: 'cost_settings'
  }, {
    text: t('notes_and_assumptions') || 'Notes & assumptions',
    link: 'notes_and_assumptions'
  }] : [])]
}, {
  key: 'reports',
  icon: 'source',
  label: t('reports') || 'Reports',
  link: 'reports',
  flyout: null
}, {
  key: 'reviews',
  icon: 'rate_review',
  label: t('review') || 'Reviews',
  link: null,
  flyout: [{
    text: t('technical_narratives') || 'Technical narrative',
    link: 'technical_narratives'
  }, ...(accountType !== 'customer' ? [{
    text: t('manager_technical_review') || 'Manager R&D review',
    link: 'manager_review'
  }, {
    text: t('client_technical_review') || 'Client technical review',
    link: 'client_review'
  }, {
    text: t('complete_claim') || 'Complete claim',
    link: 'complete_claim'
  }] : [])]
}]];
const Flyout = _ref => {
  let {
    items,
    top,
    onClose,
    sidebarWidth
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      left: sidebarWidth,
      top,
      background: '#fff',
      width: FLYOUT_WIDTH,
      borderRadius: '0 8px 8px 0',
      boxShadow: '4px 4px 16px rgba(0,0,0,0.12)',
      zIndex: 1060,
      overflow: 'hidden'
    },
    onClick: e => e.stopPropagation()
  }, items.map((item, i) => /*#__PURE__*/React.createElement(Link, {
    key: i,
    "data-testid": "sidebar-flyout-item-".concat(item.link),
    to: item.resolvedLink,
    onClick: onClose,
    style: {
      display: 'block',
      padding: '0.7rem 1.25rem',
      color: '#333',
      textDecoration: 'none',
      fontSize: '0.875rem',
      borderBottom: i < items.length - 1 ? '1px solid #f0f0f0' : 'none'
    },
    onMouseEnter: e => e.currentTarget.style.background = '#f5f9fc',
    onMouseLeave: e => e.currentTarget.style.background = 'transparent'
  }, item.text)));
};
const SidebarRow = _ref2 => {
  let {
    item,
    isActive,
    isHighlighted,
    resolvedLink,
    onToggle,
    rowRef,
    collapsed
  } = _ref2;
  const inner = /*#__PURE__*/React.createElement("div", {
    ref: rowRef,
    "data-testid": "sidebar-item-".concat(item.key),
    onClick: item.flyout ? onToggle : undefined,
    title: collapsed ? item.label : undefined,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: collapsed ? 'center' : 'space-between',
      padding: collapsed ? '0.55rem 0' : '0.55rem 1rem',
      borderRadius: '6px',
      cursor: 'pointer',
      background: isActive || isHighlighted ? '#e8f4fb' : 'transparent',
      color: '#0078B9',
      fontWeight: isHighlighted ? 600 : 400,
      userSelect: 'none',
      fontSize: '0.9rem',
      transition: 'padding 0.2s ease'
    },
    onMouseEnter: e => {
      if (!isActive && !isHighlighted) e.currentTarget.style.background = '#f5f5f5';
    },
    onMouseLeave: e => {
      if (!isActive && !isHighlighted) e.currentTarget.style.background = 'transparent';
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: collapsed ? 0 : '1rem'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '1.2rem',
      color: '#0078B9',
      flexShrink: 0
    }
  }, item.icon), !collapsed && item.label), !collapsed && item.flyout && /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '1.1rem',
      color: '#0078B9'
    }
  }, "chevron_right"));
  if (!item.flyout && resolvedLink) {
    return /*#__PURE__*/React.createElement(Link, {
      to: resolvedLink,
      style: {
        textDecoration: 'none',
        display: 'block'
      }
    }, inner);
  }
  return inner;
};
const ClaimGroupSidebarV2 = _ref3 => {
  let {
    claimGroup,
    company,
    claims,
    accountType,
    highlightedMenuItem
  } = _ref3;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [openKey, setOpenKey] = useState(null);
  const [flyoutTop, setFlyoutTop] = useState(0);
  const [collapsed, setCollapsed] = useState(false);
  const rowRefs = React.useRef({});
  const sidebarWidth = collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;
  const [claimGroups] = getClaimGroupsService.useFetchAllClaimGroups(company.id, setLoading);
  const resolvedClaims = (claims || claimGroup.claims || []).filter(claim => claim.claim_group_id === claimGroup.id);
  const getLink = menuItem => {
    var _resolvedClaims$, _resolvedClaims$2;
    const cid = claimGroup.company_id;
    const cgid = claimGroup.id;
    const at = accountType;
    if (menuItem.link === 'master') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/master");
    if (menuItem.link === 'edit/general') return "/".concat(at, "/claim_groups/").concat(cgid, "/edit/general");
    if (menuItem.link === 'edit_company_info') return "/".concat(at, "/claim_groups/").concat(cgid, "/edit/company_info");
    if (menuItem.link === 'engagement_team') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/engagement_team");
    if (menuItem.link === 'import_data') return "/".concat(at, "/claim_groups/").concat(cgid, "/data_centre/import");
    if (menuItem.link === 'export_data') return "/".concat(at, "/claim_groups/").concat(cgid, "/data_centre/export");
    if (menuItem.link === 'upload_template') return "/".concat(at, "/claim_groups/").concat(cgid, "/technical_proof/project_reports");
    if (menuItem.link === 'technical_uploads') return "/".concat(at, "/claim_groups/").concat(cgid, "/technical_uploads");
    if (menuItem.link === 'project_overview') return "/".concat(at, "/claim_groups/").concat(cgid, "/project_overview");
    if (menuItem.link === 'claim_costs') return "/".concat(at, "/claims/").concat((_resolvedClaims$ = resolvedClaims[0]) === null || _resolvedClaims$ === void 0 ? void 0 : _resolvedClaims$.id, "/financial_details/staffing_costs");
    if (menuItem.link === 'reports') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/report_template");
    if (menuItem.link === 'technical_narratives') return "/".concat(at, "/claim_groups/").concat(cgid, "/technical_narratives");
    if (menuItem.link === 'manager_review') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/manager_review");
    if (menuItem.link === 'client_review') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/client_review");
    if (menuItem.link === 'complete_claim') return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/complete_claim");
    if (menuItem.link === 'cost_settings') return "/".concat(at, "/claims/").concat((_resolvedClaims$2 = resolvedClaims[0]) === null || _resolvedClaims$2 === void 0 ? void 0 : _resolvedClaims$2.id, "/edit/general");
    if (menuItem.link === 'qualifying_expenditure') {
      var _resolvedClaims$3;
      if (!((_resolvedClaims$3 = resolvedClaims[0]) !== null && _resolvedClaims$3 !== void 0 && _resolvedClaims$3.id)) return '#';
      return "/".concat(at, "/claims/").concat(resolvedClaims[0].id, "/financial_details/summary");
    }
    if (menuItem.link === 'notes_and_assumptions') {
      var _resolvedClaims$4;
      if (!((_resolvedClaims$4 = resolvedClaims[0]) !== null && _resolvedClaims$4 !== void 0 && _resolvedClaims$4.id)) return '#';
      return "/".concat(at, "/claims/").concat(resolvedClaims[0].id, "/financial_details/notes_and_assumptions");
    }
    if (menuItem.link === 'dashboard') return getDashboardLink(company, at, claimGroup);
    return "/".concat(at, "/companies/").concat(cid, "/").concat(cgid, "/").concat(menuItem.link);
  };
  const handleToggle = item => {
    if (openKey === item.key) {
      setOpenKey(null);
      return;
    }
    const el = rowRefs.current[item.key];
    if (el) {
      const rect = el.getBoundingClientRect();
      setFlyoutTop(rect.top);
    }
    setOpenKey(item.key);
  };
  const handleCollapsedDirectLink = item => {
    if (!collapsed || item.flyout) return;
    const el = rowRefs.current[item.key];
    if (el) {
      const rect = el.getBoundingClientRect();
      setFlyoutTop(rect.top);
    }
    setOpenKey(item.key);
  };
  const closeFlyout = () => setOpenKey(null);
  const sections = buildSections(t, accountType);
  const activeFlyoutItem = sections.flat().find(i => i.key === openKey && i.flyout);
  const isItemHighlighted = item => {
    if (highlightedMenuItem === item.key) return true;
    if (highlightedMenuItem === item.link) return true;
    if (item.flyout) {
      return item.flyout.some(fi => fi.link === highlightedMenuItem);
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, openKey && /*#__PURE__*/React.createElement("div", {
    onClick: closeFlyout,
    style: {
      position: 'fixed',
      inset: 0,
      zIndex: 1050
    }
  }), activeFlyoutItem && activeFlyoutItem.flyout && /*#__PURE__*/React.createElement(Flyout, {
    items: activeFlyoutItem.flyout.map(fi => _objectSpread(_objectSpread({}, fi), {}, {
      resolvedLink: getLink(fi)
    })),
    top: flyoutTop,
    onClose: closeFlyout,
    sidebarWidth: sidebarWidth
  }), collapsed && openKey && !(activeFlyoutItem !== null && activeFlyoutItem !== void 0 && activeFlyoutItem.flyout) && (() => {
    const item = sections.flat().find(i => i.key === openKey);
    if (!item || item.flyout) return null;
    const resolvedLink = getLink(item);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'fixed',
        left: sidebarWidth,
        top: flyoutTop,
        background: '#fff',
        width: FLYOUT_WIDTH,
        borderRadius: '0 8px 8px 0',
        boxShadow: '4px 4px 16px rgba(0,0,0,0.12)',
        zIndex: 1060,
        overflow: 'hidden'
      },
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement(Link, {
      to: resolvedLink,
      "data-testid": "sidebar-flyout-item-".concat(item.link),
      onClick: closeFlyout,
      style: {
        display: 'block',
        padding: '0.7rem 1.25rem',
        color: '#333',
        textDecoration: 'none',
        fontSize: '0.875rem'
      },
      onMouseEnter: e => e.currentTarget.style.background = '#f5f9fc',
      onMouseLeave: e => e.currentTarget.style.background = 'transparent'
    }, item.label));
  })(), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      left: 0,
      top: 56,
      bottom: 0,
      width: sidebarWidth,
      background: '#fff',
      borderRight: '1px solid #e8e8e8',
      display: 'flex',
      flexDirection: 'column',
      padding: '1rem 0.5rem',
      zIndex: 1045,
      overflowY: 'auto',
      overflowX: 'hidden',
      transition: 'width 0.2s ease'
    }
  }, !collapsed && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '0.7rem',
      color: '#aaa',
      letterSpacing: '0.08em',
      padding: '0 0.5rem',
      marginBottom: '0.5rem'
    }
  }, "CLAIM"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '0.75rem',
      padding: '0 0.25rem'
    }
  }, /*#__PURE__*/React.createElement(ClaimGroupSelector, {
    accountType: accountType,
    loading: loading,
    company: company,
    claimGroup: claimGroup,
    allClaimGroups: claimGroups
  }))), sections.map((section, sIndex) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: sIndex
  }, sIndex > 0 && /*#__PURE__*/React.createElement("hr", {
    style: {
      borderColor: '#efefef',
      margin: '0.5rem 0'
    }
  }), section.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.key,
    onClick: collapsed ? () => {
      handleToggle(item);
      handleCollapsedDirectLink(item);
    } : undefined
  }, /*#__PURE__*/React.createElement(SidebarRow, {
    item: item,
    collapsed: collapsed,
    isActive: openKey === item.key,
    isHighlighted: isItemHighlighted(item),
    resolvedLink: !collapsed && !item.flyout ? getLink(item) : null,
    onToggle: () => handleToggle(item),
    rowRef: el => rowRefs.current[item.key] = el
  }))))), /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setCollapsed(c => !c);
      setOpenKey(null);
    },
    style: {
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: collapsed ? 'center' : 'flex-start',
      padding: '0.75rem 0.5rem 0',
      cursor: 'pointer',
      color: '#0078B9',
      borderTop: '1px solid #efefef'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '1.2rem'
    }
  }, collapsed ? 'chevron_right' : 'chevron_left'), !collapsed && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '0.85rem',
      marginLeft: '0.5rem'
    }
  }, "Collapse sidebar"))), /*#__PURE__*/React.createElement("style", null, "#content-wrapper { left: ".concat(sidebarWidth, "px !important; transition: left 0.2s ease; }")));
};
export default ClaimGroupSidebarV2;